import UspBlock from './UspBlock';

export default UspBlock;
